import Service from '../Service';

const resource = "extsaleorder/";

export default {

    pagination(filter, requestID) {
        return Service.post(resource + "paginationOV", filter, {
            params: { requestID: requestID }
        });
    },

    ordersalesbydocentry(filter, requestID) {
        return Service.post(resource + "ordersalesbydocentry", filter, {
            params: { requestID: requestID }
        });
    },

    list_selected(filter, requestID) {
        return Service.post(resource + "list_selected", filter, {
            params: { requestID: requestID }
        });
    },

    list_modal_search(filter, requestID) {
        return Service.post(resource + "list_modal_search", filter, {
            params: { requestID: requestID }
        });
    },

    save(saleOrder, requestID) {
        return Service.post(resource + "save", saleOrder, {
            params: { requestID: requestID }
        });
    },

    searchforguidebydocnum(filter, requestID) {
        return Service.post(resource + "searchforguidebydocnum", filter, {
            params: { requestID: requestID }
        });
    },

    getguianumber(filter, requestID) {
        return Service.post(resource + "getguianumber", filter, {
            params: { requestID: requestID }
        });
    },
}